import Home from 'pages/home';
import Design from 'pages/design';
import About from 'pages/about';
import Contact from 'pages/contact';
import Login from 'pages/login';
import Signup from 'pages/signup';
import ForgotPassword from 'pages/forgot-password';
import ForgotPasswordValidate from 'pages/forgot-password-validate';
import ConfirmEmailValidate from 'pages/confirm-email-validate';
import TermsOfService from 'pages/terms-of-service';

export default [
  {
    name: 'Design System',
    component: Design,
    path: '/design',
    exact: true,
  },
  {
    name: 'Confirm Email Validate',
    path: '/confirm-email/:token',
    component: ConfirmEmailValidate,
    exact: true,
  },
  {
    name: 'About',
    path: '/about',
    component: About,
    nav: true,
  },
  {
    name: 'Contact',
    path: '/contact',
    component: Contact,
    nav: true,
  },
  {
    name: 'Login',
    path: '/login',
    component: Login,
  },
  {
    name: 'Forgot Password',
    path: '/forgot-password',
    component: ForgotPassword,
    exact: true,
  },
  {
    name: 'Forgot Password Validate',
    path: '/forgot-password/:token',
    component: ForgotPasswordValidate,
  },
  {
    name: 'Signup',
    path: '/signup',
    component: Signup,
  },
  {
    name: 'Home',
    path: '/',
    component: Home,
    exact: true,
  },
  {
    name: 'Terms of service',
    path: '/terms-of-service',
    component: TermsOfService,
    exact: true,
  },
];
